import { RequestService } from '../../../common/services/RequestService';
import { GET_REQUEST_TYPES } from '../constants';

export const getRequestTypes = payload => {
  return RequestService.get(GET_REQUEST_TYPES);
};
